<template>
  <form class="form">
    <h2>Документ, удостоверяющий личность</h2>

    <fieldset class="form form--fieldset" disabled>
      <div class="form__group">
        <t-text :model-value="store.application.application_citizenship?.country || 'Не указано'" label="Гражданство"/>
        <t-text :model-value="store.application.identity?.document_type || 'Не указано'" label="Вид документа"/>
      </div>

      <div class="form__group">
        <t-text :model-value="store.application.identity?.series || 'Не указано'" label="Серия"/>
        <t-text :model-value="store.application.identity?.number || 'Не указано'" label="Номер"/>
        <t-text :model-value="store.application.identity?.date || 'Не указано'" label="Дата выдачи"/>
      </div>

      <div class="form__group">
        <t-text-growing :model-value="store.application.identity?.contragent || 'Не указано'" label="Кем выдан"/>
      </div>

      <div class="form__group">
        <t-text :model-value="store.application.identity?.contragent_code || 'Не указано'" label="Код подразделения"/>
        <div class="form__spacer"></div>
        <div class="form__spacer"></div>
      </div>
    </fieldset>

    <hr>

    <h2>СНИЛС</h2>

    <fieldset class="form form--fieldset" disabled>
      <div class="form__group">
        <t-text :model-value="store.application.snils || 'Не указано'" label="Номер СНИЛС"/>
        <div class="form__spacer"></div>
        <div class="form__spacer"></div>
        <div class="form__spacer"></div>
      </div>
    </fieldset>
  </form>
</template>

<script setup>
import { TText, TTextGrowing } from '@shared/ui'
import { useApplicationStore } from '@widgets/application-profile'

const store = useApplicationStore()
</script>
